import { useTranslation } from "react-i18next";
import * as yup from "yup";

const useEditDistributionSchema = () => {
    const { t } = useTranslation();

    return yup.object({ editDistributionType: yup.string().required(t("messages.inputMsgs.required")) });
};

export default useEditDistributionSchema;
